import { render, staticRenderFns } from "./KnowledgeBaseCategoryPublication.vue?vue&type=template&id=74085a3e&scoped=true&"
import script from "./KnowledgeBaseCategoryPublication.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseCategoryPublication.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseCategoryPublication.vue?vue&type=style&index=0&id=74085a3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74085a3e",
  null
  
)

export default component.exports